import { DropZonePinComponentSettings, TextSettings } from '@lessonup/pins-shared';
import { CSSPropertiesWithVars } from '../../utils/pinComponents/tipTapStyles.types';

export function horizontalAlignmentToFlexValue(horizontalAlignment: TextSettings['horizontalAlignment']) {
  switch (horizontalAlignment) {
    case 'left':
      return 'start';
    case 'center':
      return 'center';
    case 'right':
      return 'end';
    default:
      return;
  }
}

export function computeTextPinComponentStyles(settings: DropZonePinComponentSettings): CSSPropertiesWithVars {
  return {
    ...(settings.fontFamily && {
      '--component-fontfamily': `"${settings.fontFamily}"`,
    }),
    ...(settings.fontSize && { '--component-fontsize': settings.fontSize }),
    ...(settings.fontColor && { '--component-fontcolor': settings.fontColor }),
    ...(settings.backgroundColor && {
      backgroundColor: settings.backgroundColor,
    }),
    borderWidth: `${settings.borderSize}px`,
    borderStyle: 'solid',
    borderRadius: `${settings.borderRadius}px`,
    borderColor: `${settings.borderColor}`,
  };
}
